module.exports = __webpack_public_path__ + "img/protocol2.e4974ae6.png";